import React from 'react'
// import the Javascript plumbing file


const HomePage = () => {

    // Load and instantiate the WebAssembly

    return (
      <div>
        <h2>Page under construction --- our ingeneous engineers are working on it</h2>
        <img  title="Our oompa loompa is processing. Please wait." src={'processing.gif'} alt="loading..."  align="middle" />
        </div>
    )
  }
  
  export default HomePage;